/* eslint-disable max-len */
const React = require('react');

const HomeCardOnlinePayment = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="83" height="59" viewBox="0 0 83 59">
    <g fill="none" fillRule="evenodd" stroke="#009EE3" strokeWidth="2">
      <g transform="translate(10 11)">
        <rect width="53" height="34" fill="#FFF" rx="1.454" />
        <path strokeLinecap="square" d="M1 7.5h50M1 14h50M6 26.5h6M16 26.5h6" />
      </g>
      <rect width="34" height="16" x="38" y="35" fill="#FFF" rx="1.454" />
      <path strokeLinecap="square" d="M42 42.5h24.6" />
    </g>
  </svg>
);

module.exports = HomeCardOnlinePayment;
